// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import ReportCriteriaFooter from '../../../reports/shared/components/report-criteria-footer';
import RgaBODealerCriteria from './rga-bo-data-type-criteria';
import RgaBOReportDates from './rga-bo-dates-criteria';
import RgaResponsibleUnitCriteria from './rga-responsible-unit-criteria';

const RgaBOCriteria = props =>
    <div className='rga-bo-report-criteria'>
        <div className='criteria-container'>
            <RgaBODealerCriteria
                onDealerSelect={props.onDealerSelect}
                onSelectAllDealers={props.onSelectAllDealers}
                selectedAccounts={props.selectedAccounts}
                selectedDealers={props.selectedDealers}
            />
            <RgaResponsibleUnitCriteria
                onResponsibleUnitChange={props.onResponsibleUnitChange}
                responsibleUnit={props.responsibleUnit}
                responsibleUnitList={props.responsibleUnitList}
            />
            <RgaBOReportDates
                dateRange={props.registrationDate}
                label='Requested Date'
                onDateChange={props.onRegistrationDateChange}
            />
        </div>
        <ReportCriteriaFooter
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onRunReport={props.onCreateReport}
            showExport={false}
            showReport={true}
        />
    </div>;

RgaBOCriteria.displayName = 'RgaBOCriteria';
RgaBOCriteria.propTypes = {
    canRunReport: PropTypes.bool.isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onRegistrationDateChange: PropTypes.func.isRequired,
    onResponsibleUnitChange: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    registrationDate: PropTypes.object.isRequired,
    responsibleUnit: PropTypes.string.isRequired,
    responsibleUnitList: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RgaBOCriteria;



// WEBPACK FOOTER //
// ./src/rga/reports/components/rga-bo-report-criteria.js